export const statusOption = [
  { key: 1, badgeColor: "warning" },
  { key: 2, badgeColor: "success" },
  { key: 3, badgeColor: "danger" },
];

export const busRecordStatusMode = {
  ACTIVE: "O",
  INACTIVE: "C",
};

export const busModeList = {
  VIEW_BUS_DETAIL: "VIEW_BUS_DETAIL",
  EDIT_BUS_DETAIL: "EDIT_BUS_DETAIL",
};

export const getInitOrderScanParams = () => {
  return {
    sizePerPage: 10,
    page: 1,
    sort: "-scanner_date",
    columnFilter: {},
    keywords: "",
    columnsVisible: {},
    fields:
      "object.id,scan_code,object_code,object_ref_code,status,action_type,order_status,scanner,scanner_date,id,scanId",
    expand: "",
    tracking_key: undefined,
    scan_id: undefined,
  };
};

export const mapArrayToObject = array => {
  const obj = {};
  for (const item of array) {
    obj[item.value] = item.label;
  }
  return obj;
};
